
























import Vue from 'vue';
import { default as Component } from 'vue-class-component';

@Component({
  props: {
    position: Number,
    isMobile: Boolean
  }
})
export default class HsgProductImage extends Vue {}
